<template>
  <div>
    <h1>
      Configuración de correo
    </h1>
		<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>
    <form class="form-inline">
      <div class="form-group">
        <label for="email">Email:</label>
        <input v-model="form.email" type="email" class="form-control" id="email" style="width: 80%" v-on:keyup="search = true">
        <div class="box" v-if="mail_configs.length > 0">
          <ul class="box-list">
            <li v-for="mail_config in mail_configs" :key="mail_config.id" class="box-item" @click.prevent="selectMailConfig(mail_config)">
              {{ mail_config.email }}
            </li>
          </ul>            
        </div>
      </div>
      <div class="form-group">
        <label for="emails">Emails (separados por ,)</label>
        <input v-model="form.emails" type="text" class="form-control" id="emails" style="width: 80%">
      </div>      
      <div class="form-group custom-switch">
        <input v-model="form.retry" type="checkbox" class="custom-control-input" id="customSwitch1">
        <label class="custom-control-label" for="customSwitch1">Reintentar envío de correo</label>
      </div>
      <div class="form-group select-custom" v-if="form.retry">
        <label for="email"> cada :</label>
        <select v-model="form.forwarding_period" class="form-control">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>          
        </select>        
        <label for="">días hábiles</label>
      </div>      
    </form>
    <div class="row row-required-attachments">
      <div class="col-sm-12">
        <label for="">Documentos requeridos por parte de la institución</label>
        <textarea v-model="form.required_attachments" class="form-control" id="required_attachments" rows="3"></textarea>                
      </div>
    </div>
    <button @click.prevent="createUpdateContract" type="submit" class="btn btn-success">Guardar</button>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'MailConfigForm',
  props: ['academic_reference', 'mail_config'],
  data() {
    return {
      token: '',
      form: {
        retry: true,
        mail_config_level: 'mail_config_level_undefined'
      },
      message: '',
      typeMessage: '',
      search: false,
      mail_configs: [],
      email_copy: ''
    }
  },
  methods: {
    setCredentials(){
      axios.defaults.headers['x-csrf-token'] = this.token
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    createUpdateContract() {
      this.setCredentials()
      if (this.form.id != null) {
        this.update()
      } else {
        this.create()
      }
    },    
    create() {
      axios.post(`/mail_configs`, { mail_config: this.form, academic_reference_id: this.academic_reference.id}, {}).then(res=>{
        if (res.status == 201) {
          this.form = res.data.mail_config
          this.showMessage('Configuración creada', 'alert-success')          
        }        
      }, (err) => {
        this.showMessage('No se pudo crear la configuración del email', 'alert-danger')
      })
    },
    update() {
      axios.put(`/mail_configs/${this.form.id}`, { mail_config: this.form, academic_reference_id: this.academic_reference.id}, {}).then(res=>{
        if (res.status == 200) {
          this.form = res.data.mail_config
          this.showMessage('Configuración actualizada', 'alert-success')          
        }        
      }, (err) => {
        this.showMessage('No se pudo actualizar la configuración del email', 'alert-warning')
      })      
    },
    searchMailConfig(){
      this.setCredentials()
      axios.get(`/search/mail_configs?q[email_cont]=${this.form.email}`, {}, {}).then(res=>{
        if (res.status == 200) {
          this.mail_configs = res.data.mail_configs
        }
      })      
    },
    selectMailConfig(mail_config){
      this.form = mail_config
      this.mail_configs = []
      this.search = false
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 3000)
    },
  },
  watch: {
    'form.email'() {
      if (this.search && this.form.email != '') {
        if (this.email_copy != this.form.email) {
          this.searchMailConfig() 
        }        
      }
      if (this.form.email == '' || this.email_copy == this.form.email) {
        this.mail_configs = []
        this.search = false
      }      
    }
  },
  created () {
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')    
    if (this.mail_config != null) {
      this.form = this.mail_config
      this.email_copy = this.form.email
    } else {
      if (this.academic_reference.academic_type == 'elementary') {
        this.form.mail_config_level = 'mail_config_elementary'
      }
      if (this.academic_reference.academic_type == 'superior') {
        this.form.mail_config_level = 'mail_config_superior'
      }      
    }    
  }
}
</script>

<style scoped>
  .row-required-attachments{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .select-custom{
    margin-top: 0.2rem !important;
  }
  .box {
    position: absolute;
    padding: 0.5rem;
    color: #58595c;
    font-size: 15px;
    overflow-y: scroll;
    height: 120px;
    width: max-content;
    height: max-content;
    background-color: #ffffff;
    border: 1px solid #dddcdc;
    border-radius: 5px;
    z-index: 1;
    margin-left: 3rem;
  }
  .box-list{
    list-style: none;
    padding-left: 0.1rem;
  }
  .box-item{
    cursor: pointer;
  }  
</style>